
import React from 'react';
import ReactDOM from 'react-dom';
import '../../../../styles/dropdownMenuCellRenderer.scss';

class DropdownMenuCellRenderer extends React.Component {
  constructor(props) {
    super(props);
    this.state = { position: { top: 0, left: 0 } };
    this.buttonRef = React.createRef();
    this.menuContainer = document.createElement('div');
    this.menuContainer.className = 'dropdown-portal-container';
    this.isMenuContainerAppended = false;
    // We have disabled the move placement because we have now below bug
    // MED-11018
    // -omni dropdown search problem
    // after move placement the placement is not able to send to MO (backend bug) 
    // because we send current placement id and destination id only in form submit.
    this.DISABLE_MOVE_PLACEMENT = true;
  }

  componentDidMount() {
    if (!this.isMenuContainerAppended) {
      document.body.appendChild(this.menuContainer);
      this.isMenuContainerAppended = true;
    }
    document.addEventListener('mousedown', this.handleOutsideClick, true);
    document.addEventListener('scroll', this.handleOutsideClick, true);
  }

  componentWillUnmount() {
    if (this.isMenuContainerAppended) {
      document.body.removeChild(this.menuContainer);
      this.isMenuContainerAppended = false;
    }
    document.removeEventListener('mousedown', this.handleOutsideClick, true);
  }

  /**
   * function will close meanu  
   * @param {object} e it's hold all params related to click element
   */
  handleOutsideClick = (e) => {
    let isMenuClassAvialble = document.getElementsByClassName('dropdown-portal-menu');
    if (
      this.buttonRef.current &&
      !this.buttonRef.current.contains(e.target) &&
      this.menuContainer &&
      !this.menuContainer.contains(e.target) &&
      isMenuClassAvialble.length
    ) {
      this.props.onToggle(null); // tell parent to close all
    }
  };

  /**
   * set the position of meanu near where user click
   * @param {object} e it's event gerated on click
   */
  toggleMenu = (e) => {
    e.stopPropagation();

    const rect = this.buttonRef.current.getBoundingClientRect();
    this.setState({
      position: {
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX + 120,
      },
    });

    this.props.onToggle(this.props.id); // notify parent
  };

  /**
   * Handles dropdown menu actions
   * @param {string} action - The action to perform ('move placement' or 'unPackage')
   */
  handleAction = (action) => {
    const id = this.props.id || (this.props.data && this.props.data.id);
    if (!id) {
      return;
    }

    if (action === "move placement") {
      this.props.movePlacement(id);
    } else if (action === "unPackage") {
      this.props.confirmUnPackageMsg(id);
    }

    this.props.onToggle(null); // Close dropdown after action
  };

  /**
   * create action item for modal in html with all condtions
   * @returns action meanu in html
   */
  renderMenu() {
    const { top, left } = this.state.position;
    if (!this.props.isOpen) return null;
    
    // Safely get data
    const data = this.props.data || {};
    const exportStatus = data.export_status || '';
    const isDisabled = ['accepted'].includes(exportStatus.toLowerCase());
    
    return ReactDOM.createPortal(
      <div
        className="dropdown-portal-menu"
        style={{ top, left, position: 'absolute', zIndex: 9999 }}
      >
       {this.props.showContent && <div className="dropdown-content-actions">
          {!this.DISABLE_MOVE_PLACEMENT && this.props.moveable && 
            <a 
              className={isDisabled ? 'disabled' : ''} 
              onMouseDown={(e) => {
                e.stopPropagation();
                this.handleAction("move placement");
              }}
            >
              Move placement
            </a>
          }
          {this.props.unpackage && 
            <a 
              className={isDisabled ? 'disabled' : ''} 
              onMouseDown={(e) => {
                e.stopPropagation();
                this.handleAction("unPackage");
              }}
            >
              Unpackage
            </a>
          }
        </div>
        }
      </div>,
      this.menuContainer
    );
  }

  render() {
    return (
      <>
        <button
          ref={this.buttonRef}
          className="button is-text is-shadowless dropdown-toggle"
          onClick={this.toggleMenu}
        >
          ⋮
        </button>
        {this.renderMenu()}
      </>
    );
  }
}

export default DropdownMenuCellRenderer;
